import { motion, useReducedMotion } from 'framer-motion';

export const EASE = [0.16, 1, 0.3, 1];

export const staggerParent = (stagger = 0.1, delay = 0.05) => ({
  hidden: {},
  visible: { transition: { staggerChildren: stagger, delayChildren: delay } }
});

export const staggerChild = (y = 24, x = 0) => ({
  hidden: { opacity: 0, y, x },
  visible: { opacity: 1, y: 0, x: 0, transition: { duration: 0.75, ease: EASE } }
});

const OFFSETS = {
  up: (d) => ({ y: d }),
  down: (d) => ({ y: -d }),
  left: (d) => ({ x: -d }),
  right: (d) => ({ x: d }),
  none: () => ({})
};

const DEFAULT_DISTANCE = { up: 28, down: 28, left: 56, right: 56, none: 0 };

function Reveal({
  as = 'div',
  from = 'up',
  distance,
  children,
  className = '',
  delay = 0,
  duration = 0.8,
  amount = 0.2,
  once = true,
  ...rest
}) {
  const reduce = useReducedMotion();
  const Component = motion[as] || motion.div;
  const offset = OFFSETS[from](distance ?? DEFAULT_DISTANCE[from]);

  return (
    <Component
      className={className}
      initial={reduce ? false : { opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount, margin: '0px 0px -8% 0px' }}
      transition={{ duration, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default Reveal;
